<!--  -->
<template>
  <div>
    <div class="examples_rightbox">
      <div class="input_box">
        <div>标题：</div>
        <div><el-input v-model="form.title" placeholder="请输入标题" /></div>
      </div>
      <div class="input_box">
        <div>链接：</div>
        <div><el-input v-model="form.url" style="width:300px" placeholder="请输入链接" /></div>
      </div>
      <div class="input_box">
        <div>描述：</div>
        <div>
          <el-input v-model="form.description" style="width:300px" type="textarea" placeholder="请输入描述" />
        </div>
      </div>
      <div class="cover_box">
        <div>封面：</div>
        <el-button type="primary" size="mini" @click="materiallibrary">选择封面</el-button>
      </div>
      <img v-if="form.testsrc" :src="form.testsrc" class="uopatatextimg">
    </div>
    <div style="margin-left:65px;margin-top:10px"><el-button type="primary" @click="sumbit">确定</el-button></div>
    <!-- 上传图片弹窗 -->
    <el-dialog
      title="图片库"
      :visible.sync="dialogVisibletwo"
      width="50%"
      append-to-body
    >
      <chooseimg ref="mychild" @clickicon="clickicon" />
    </el-dialog>
  </div>
</template>

<script>
import chooseimg from '../../menumanagement/components/chooseimg.vue'
export default {
  components: { chooseimg },
  data() {
    return {
      form: {
        title: '',
        url: '',
        description: '',
        testsrc: '',
        source_material_id: ''
      },
      dialogVisibletwo: false
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    materiallibrary() {
      this.dialogVisibletwo = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.parentHandleclick('1')
      }, 100)
    },
    clickicon(img, key) {
      this.dialogVisibletwo = false
      this.form.testsrc = img
      this.form.source_material_id = key
    },
    send(item) {
      // eslint-disable-next-line eqeqeq
      if (JSON.stringify(item) == '{}') {
        console.log('item', item)
      } else {
        console.log('item1', item)
        this.form.title = item.title
        this.form.url = item.url
        this.form.description = item.desc
        this.form.testsrc = item.picurl
        this.form.source_material_id = item.source_material_id
      }
    },
    sumbit() {
      if (this.form.title === '') {
        this.$message.error('请填写标题')
        return
      }
      if (this.form.url === '') {
        this.$message.error('请填写链接')
        return
      }
      if (this.form.description === '') {
        this.$message.error('请填写描述')
        return
      }
      if (this.form.testsrc === '') {
        this.$message.error('请选择封面')
        return
      }
      this.$emit('callback', this.form)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.examples_rightbox{
  margin-left: 30px;
}
.input_box{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.cover_box{
  display: flex;
  align-items: center;
}
.uopatatextimg{
  width: 80px;
  height: 80px;
  margin-top: 20px;
  margin-left: 40px;
}
</style>
